import React from 'react'
import { useRef, useCallback } from 'react'

const Context = React.createContext([])
const { Provider } = Context

export const useServiceOrderContextEvents = () => React.useContext(Context)
export default function ServiceOrderContextEvents({ children }) {
  const events = useRef()

  const setEvents = useCallback(serviceOrderEvents => {
    events.current = serviceOrderEvents
  }, [])

  return <Provider value={{ events, setEvents }}>{children}</Provider>
}
